import React from "react";
import { Drawer } from "@mui/material";

const DrawerView = ({ isOpen, setIsOpen, content }) => {
  const onCloseDrawer = () => {
    setIsOpen(false);
  };

  return (
    <div>
      <Drawer anchor="right" open={isOpen} onClose={onCloseDrawer}>
        {content}
      </Drawer>
    </div>
  );
};

export default DrawerView;
